import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-scc-user',
  templateUrl: './scc-user.component.html',
  styleUrls: ['./scc-user.component.scss']
})
export class SccUserComponent implements OnInit {
  @Input() userFormGroup: FormGroup = new FormGroup({});
  @Input() orderNumber = '';
  @Input() firstname = '';
  @Input() lastname = '';
  @Input() mail = '';
  @Input() usePassword = false;

  constructor(
    private readonly formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.userFormGroup.addControl('email', this.formBuilder.control(this.mail ?? '', [Validators.required, Validators.email]));
    this.userFormGroup.addControl('firstName', this.formBuilder.control(this.firstname ?? '', Validators.required));
    this.userFormGroup.addControl('lastName', this.formBuilder.control(this.lastname ?? '', Validators.required));
    this.userFormGroup.addControl('orderNum', this.formBuilder.control(this.orderNumber ?? '', Validators.required));
    this.userFormGroup.addControl('password', this.formBuilder.control('', this.usePassword ? Validators.required : undefined));

    if (!this.usePassword) {
      this.userFormGroup.get('password')?.disable();
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    // const userAlreadyExist: AsyncValidatorFn = (control: AbstractControl): Observable<ValidationErrors | null> => this.adminUserService.getUserByEmail((control.value as string).trim()).pipe(
    //   debounceTime(250),
    //   map((res: UserDetailsInterface) => res ? { alreadyExist: true } : null)
    // );
    //
    // this.userFormGroup.get('email')?.setAsyncValidators(userAlreadyExist);
  }
}
